<script setup lang="ts">
import { reactive, ref } from 'vue'
import boundaryData from './components/boundaryData.vue'
import bullBearData from './components/bullBearData.vue'
import comparative from './components/comparative.vue'
import warrantData from './components/warrantData.vue'
import { useElementSize } from '@vueuse/core'
// 页面配置
definePage({
  name: 'TrialByOrdeal',
  meta: {
    title: '轮证',
  },
})

// const coreHoldingDataBox = reactive([
//   { name: '核心仓', value: 41.7, color: '#409eff' },
//   { name: '主力仓', value: 25.89, color: '#67c23a' },
//   { name: '观察仓', value: 20.70, color: '#e6a23c' },
//   { name: '其它', value: 10.71, color: '#808080' },

// ])

// // 模拟核心仓数据
// const coreHoldingData = reactive([
//   { name: '腾讯控股', value: 42.37, color: '#409eff' },
//   { name: '阿里巴巴 - W', value: 22.45, color: '#67c23a' },
//   { name: '小米集团 - W', value: 12.61, color: '#e6a23c' },
//   { name: '中芯国际', value: 11.64, color: '#f56c6c' },
//   { name: '美团 - W', value: 9.13, color: '#909399' },
//   { name: '其它', value: 1.70, color: '#808080' },
// ])

// // 模拟核心仓占比数据
// const coreHoldingRatioData = reactive([
//   { name: '腾讯控股', value: 42.37, color: '#409eff' },
//   { name: '阿里巴巴 - W', value: 22.45, color: '#67c23a' },
//   { name: '小米集团 - W', value: 12.61, color: '#e6a23c' },
//   { name: '中芯国际', value: 11.64, color: '#f56c6c' },
//   { name: '美团 - W', value: 9.13, color: '#909399' },
//   { name: '其它', value: 1.70, color: '#808080' },
// ])
// / 为不同类型的数据创建响应式数据

// const bullBearData = reactive([ // 牛熊数据
//   {
//     name: '腾讯牛证',
//     code: '54321.HK',
//     marketValue: '9.8亿',
//     cycle: '30天',
//     coreRatio: '35.20%',
//     totalRatio: '9.82%',
//   },
//   {
//     name: '阿里熊证',
//     code: '65432.HK',
//     marketValue: '7.5亿',
//     cycle: '60天',
//     coreRatio: '28.45%',
//     totalRatio: '8.53%',
//   },
//   {
//     name: '美团牛证',
//     code: '76543.HK',
//     marketValue: '5.2亿',
//     cycle: '45天',
//     coreRatio: '18.60%',
//     totalRatio: '7.23%',
//   },
//   {
//     name: '小米熊证',
//     code: '87654.HK',
//     marketValue: '3.9亿',
//     cycle: '90天',
//     coreRatio: '12.35%',
//     totalRatio: '5.82%',
//   },
// ])

// const boundaryData = reactive([ // 界内数据
//   {
//     name: '腾讯界内证',
//     code: '98765.HK',
//     marketValue: '15.2亿',
//     cycle: '270天',
//     coreRatio: '40.10%',
//     totalRatio: '12.52%',
//   },
//   {
//     name: '阿里界内证',
//     code: '87654.HK',
//     marketValue: '11.6亿',
//     cycle: '180天',
//     coreRatio: '25.80%',
//     totalRatio: '10.23%',
//   },
//   {
//     name: '美团界内证',
//     code: '76543.HK',
//     marketValue: '8.9亿',
//     cycle: '365天',
//     coreRatio: '19.75%',
//     totalRatio: '8.92%',
//   },
//   {
//     name: '小米界内证',
//     code: '65432.HK',
//     marketValue: '6.3亿',
//     cycle: '90天',
//     coreRatio: '14.35%',
//     totalRatio: '6.82%',
//   },
// ])

const indexData = reactive({
  name: '恒生指数(HSI.HK)',
  price: '25690.53',
  changePercent: '+0.75%',
  changeValue: '+1',
})
const activeName = ref('a')

// function tabsfun() {
//   if (activeName.value === 'a') {
//     title.value = '窝轮'
//     holdingDetailData.value = warrantData
//   }
//   else if (activeName.value === 'b') {
//     title.value = '牛熊'
//     holdingDetailData.value = bullBearData
//   }
//   else if (activeName.value === 'c') {
//     title.value = '界内'
//     holdingDetailData.value = boundaryData
//   }
//   else {
//     title.value = '街活分布'
//   }
// }

const refsPageLayout = useTemplateRef('refsPageLayout')
const navbarHeight = computed(() => {
  return `${refsPageLayout.value?.navbarHeight || 0}px`
})
const refTabConten = useTemplateRef('refTabConten')
const { height: tabContenHeight } = useElementSize(refTabConten, undefined, { box: 'border-box' })
</script>

<template>
   <FmPageLayout navbar :search="false" back ref="refsPageLayout" >
    <template #navbar-end>
      <FmIcon name="material-symbols:help-outline-rounded" class="text-22px color-[#fff]" />
      <FmIcon name="ri:share-forward-box-line" class="m-l-16px text-22px color-[#fff]" />
    </template>
     <div class="fund-flow-page">
       <div class="tabdiv" ref="refTabConten"  :style="{ top: navbarHeight }">
         <van-tabs v-model:active="activeName" line-width="9px" >
           <van-tab title="窝轮" name="a" />
           <van-tab title="牛熊" name="b" />
           <van-tab title="界内" name="c" />
           <van-tab title="街活分布" name="d" />
         </van-tabs>
       </div>
       <div :style="{ height: `${tabContenHeight}px` }"></div>
         <div class="search-section">
           <div class="search-content">
             <div class="color-[#333333] text-16px font-medium">
               {{ indexData.name }}
             </div>
             <div class="color-[#E51A2D] text-14px">
               {{ indexData.price }}<span :class="indexData.changePercent.startsWith('+') ? 'up' : 'down'">
                 {{ indexData.changePercent }}
               </span>
               <span :class="indexData.changeValue.startsWith('+') ? 'up' : 'down'">
                 {{ indexData.changeValue }}
               </span>
             </div>
           </div>
           <div class="search-icon-container">
             <img src="@/assets/images/search.png" alt="" width="17px">
           </div>
         </div>

         <warrantData v-if="activeName === 'a'" />
         <bullBearData v-else-if="activeName === 'b'" />
         <boundaryData v-else-if="activeName === 'c'" />
         <div v-else>
           <comparative />
         </div>

     </div>
   </FmPageLayout>
</template>

<style scoped lang="scss">
.fund-flow-page {
  height: 100%;
  background-color: #fff;

  :deep(.van-tabs__nav) {
    background-color: #f1f2f7;
  }

  :deep(.van-tab--active) {
    font-size: 17px;
  }

  .tabdiv {
    position: fixed;
    left: 0;
    z-index: 100;
    width: 100%;
  }
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 0;
  color: white;
  background-color: #007aff;
}

.header-left,
.header-right {
  display: flex;
  align-items: center;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
}

.back-btn {
  padding: 8px;
  color: white;
  cursor: pointer;
  background: none;
  border: none;
}

.notice-bar {
  display: flex;
  justify-content: space-between;
  // margin-bottom: 16px;
  height: 17px;
  padding: 2px 16px;
  font-size: 12px;
  color: #999;
  text-align: center;
  background-color: white;
}

.core-holding-section {
  margin-bottom: 16px;
  overflow: hidden;
  background-color: white;
  border-radius: 8px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 16px 16px 0;
  // border-bottom: 1px solid #eee;

  span {
    font-family: PingFangSC, "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    color: #333;
    text-align: left;
  }
}

.section-header2 {
  align-items: center;
  justify-content: flex-start;
  padding: 16px;

  // border-bottom: 1px solid #eee;
  span {
    font-family: PingFangSC, "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    color: #333;
    text-align: left;
  }
}

.section-actions {
  display: flex;
  gap: 10px;
  margin: 0 10px;

  img {
    width: 14px;
    height: 14px;
  }
}

.info-btn {
  padding: 8px;
  color: #999;
  cursor: pointer;
  background: none;
  border: none;
}

.holding-info {
  // display: flex;
  gap: 16px;
  padding: 0 16px;
}

.holding-chart-container {
  // flex: 1;
  width: 100%;
  height: 250px;
  // overflow: hidden;
  border-radius: 8px;
}

.chart-container {
  width: 100%;
  height: 100%;
  // overflow: hidden;
  background-color: white;
}

.chart-container2 {
  width: 100%;
  height: 100%;
  min-height: 280px;
  // overflow: hidden;
  background-color: white;
}

.holding-stats {
  display: flex;
  // flex-direction: column;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;
  border-top: 1px solid #eee;
}

.stat-item {
  display: flex;
  flex: 1;
  flex-wrap: nowrap;
  gap: 20px;
  justify-content: center;
  height: 46px;
  font-size: 14px;
  line-height: 46px;
  color: #333;
}

.label {
  font-family: PingFangSC, "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 46px;
  color: #999;
  text-align: left;
}

.value {

  // font-weight: 500;
  font-family: PingFangSC, "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 46px;
  color: #333;
  text-align: left;
}

.core-holding-detail-section {
  margin-bottom: 16px;
  overflow: hidden;
  background-color: white;
  border-radius: 8px;
}

.holding-detail-container {
  width: 100%;
  min-height: 300px;
  // display: flex;
  // gap: 16px;
  padding: 0 16px;
}

.legend-container {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
}

.legend-item {
  display: flex;
  gap: 8px;
  align-items: center;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.legend-text {
  font-size: 14px;
  color: #333;
}

.legend-value {
  margin-left: auto;
  font-size: 14px;
  color: #666;
}

.holding-detail-section {
  overflow: hidden;
  background-color: white;
  border-radius: 8px;
}

.detail-table {
  border-top: 1px solid #eee;
}

.table-header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  padding: 12px 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #eee;
}

.header-cell {
  position: relative;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  color: #666;
  text-align: left;

  .header--min {
    font-size: 12px;
    line-height: 14px;
  }
}

.table-body {
  /* display: grid; */
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.table-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.cell {
  width: 24%;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.stock-name {
  font-weight: 600;
}

.stock-code {
  font-size: 12px;
  color: #666;
}

.time-display {
  font-size: 12px;
  color: #999;
}

.time-picker {
  :deep(.el-input__wrapper) {
    padding: 0;
    font-size: 12px;
    background-color: transparent;
    border: none;
    box-shadow: none;
  }
}

::v-deep .van-tabs__nav {
  background-color: #f1f2f7;
}

.sort-icons {
  position: absolute;
  top: 50%;
  right: 5px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  transform: translateY(-50%);

  .sort-icon {
    font-size: 10px;
    line-height: 1;
    color: #999;
    cursor: pointer;

    &:hover {
      color: #409eff;
    }
  }

  .sort-asc {
    margin-bottom: -4px;
  }
}

.search-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 8px;
  // border-bottom: 1px solid #eee;
}

.search-content {
  flex: 1;
  overflow: hidden;
}

.index-name {
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
}

.index-price {
  margin-bottom: 4px;
  font-size: 18px;
  font-weight: 600;
  color: #f56c6c;
}

.index-change {
  display: flex;
  gap: 8px;
  font-size: 14px;
}

.up {
  color: #f56c6c;
}

.down {
  color: #f56c6c;
}

.search-icon-container {
  margin-left: 16px;
  cursor: pointer;

  &:hover .search-icon {
    color: #409eff;
  }
}

.search-icon {
  width: 18px;
  height: 18px;
}

.iconlist {
  display: flex;
  font-size: 14px;
  color: #3c78ff;
}
</style>
